import React from "react";
import styles from "./styles";
import { withStyles } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";
import CustomTextField from "../../common/CustomTextField";
import Select from "../../../../../../common/StyledSelect";
import {
  MAX_LENGTH_CONSTRAINTS,
  MAX_VALUE_CONSTRAINTS,
} from "../../common/constants";
import {ONLY_NUMBER_REGEX, ALPHA_NUMERIC_REGEX} from "../../../constRegex"
import {
  COUNTRIES,
  CITY_VALUE_PARAMS,
  CONSIGNEE_NAME_VALUE_PARAMS,
} from "../../../constants";

const ProDetails = ({
  classes,
  editInfo,
  errorInfo,
  countryList,
  cityList,
  handleBlur,
  consigneeList,
  handleChange,
  stopData,
  proNumberLength
}) => {
  let shipperList = [];
  if (stopData.isWarehousePickup) {
    shipperList = stopData.warehousePickupShippers.map((shipper) => {
      return { label: shipper.shipperName, value: shipper.rmaxShipperCode };
    });
  }
  return (
    <div id="proDetails">
      <Typography variant="subtitle1" className={classes.headerLabel}>
        PRO DETAILS
      </Typography>
      <CustomTextField
        className={classes.fullWidth}
        id="proNumber"
        handleChange={handleChange("proNumber")}
        onBlur={handleBlur}
        value={editInfo.proNumber}
        error={errorInfo.proNumber}
        disabled={editInfo.isProPreAssigned}
        label="Pro Number"
        inputProps={{
          pattern: ONLY_NUMBER_REGEX,
          maxLength: proNumberLength,
        }}
      />

      {stopData.isWarehousePickup && (
        <div className={classes.flexRow}>
          <Select
            textFieldProps={{
              id: "shipperName",
              label: "Shipper Name",
              variant: "outlined",
              helperText: errorInfo.rmaxShipperCode,
            }}
            value={editInfo.rmaxShipperCode}
            error={Boolean(errorInfo.rmaxShipperCode)}
            onChange={handleChange("rmaxShipperCode")}
            data={shipperList}
          />
        </div>
      )}
      <div className={classes.flexRowWithSpacing}>
        <div className={`${classes.flexRow} ${classes.countryDetailWidth}`}>
          <Select
            textFieldProps={{
              id: "consigneeCountry",
              label: "Country",
              variant: "outlined",
              helperText: errorInfo.consigneeCountry,
            }}
            value={editInfo.consigneeCountry}
            error={Boolean(errorInfo.consigneeCountry)}
            onChange={handleChange("consigneeCountry")}
            data={countryList}
          />
        </div>
        <CustomTextField
          className={classes.countryDetailWidth}
          id="consigneeZip"
          handleChange={handleChange("consigneeZip")} // zipcode needs to sent as string field
          value={editInfo.consigneeZip}
          error={errorInfo.consigneeZip}
          label="Zip Code"
          hideIncrementer
          inputProps={{
            maxLength: MAX_LENGTH_CONSTRAINTS.PICKUP_PRO_FORM.ZIP,
            max: MAX_VALUE_CONSTRAINTS.PICKUP_PRO_FORM.ZIP,
            pattern:
              editInfo.consigneeCountry === COUNTRIES.CN
                ? ALPHA_NUMERIC_REGEX
                : ONLY_NUMBER_REGEX,
          }}
        />
      </div>
      <div className={classes.flexRow}>
        <Select
          textFieldProps={{
            id: "consigneeName",
            label: "Consignee Name",
            variant: "outlined",
            maxLength: MAX_LENGTH_CONSTRAINTS.PICKUP_PRO_FORM.CONSIGNEE_NAME,
            helperText: errorInfo.consigneeName,
          }}
          value={editInfo.consigneeName}
          error={Boolean(errorInfo.consigneeName)}
          newValueParams={CONSIGNEE_NAME_VALUE_PARAMS}
          onChange={handleChange("consigneeName")}
          data={consigneeList}
          canAcceptNewValue
          createLabel="Add Consignee Name"
        />
      </div>
      <div className={classes.flexRow}>
        <Select
          textFieldProps={{
            id: "consigneeCity",
            label: "City",
            variant: "outlined",
            maxLength: MAX_LENGTH_CONSTRAINTS.PICKUP_PRO_FORM.CONSIGNEE_CITY,
            helperText: errorInfo.consigneeCity,
          }}
          newValueParams={CITY_VALUE_PARAMS}
          value={editInfo.consigneeCity}
          error={Boolean(errorInfo.consigneeCity)}
          onChange={handleChange("consigneeCity")}
          data={cityList}
          canAcceptNewValue
          createLabel="Add City"
        />
      </div>
    </div>
  );
};

export default withStyles(styles)(ProDetails);
